export const BackgroundColor = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const BackgroundColorStrong = {
  value: "#f7f7f7",
  attributes: {
    appearance: {
      dark: {
        value: "#2d2e31"
      }
    }
  }
};
export const BackgroundColorStronger = {
  value: "#eeeeee",
  attributes: {
    appearance: {
      dark: {
        value: "#444445"
      }
    }
  }
};
export const BackgroundColorStrongest = {
  value: "#bcbcbd",
  attributes: {
    appearance: {
      dark: {
        value: "#737475"
      }
    }
  }
};
export const BackgroundColorPrimary = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const BackgroundColorPrimarySubdued = {
  value: "#E0F2FF",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA33"
      }
    }
  }
};
export const BackgroundColorSuccess = {
  value: "#007A4D",
  attributes: {
    appearance: {
      dark: {
        value: "#49CC93"
      }
    }
  }
};
export const BackgroundColorSuccessSubdued = {
  value: "#CEF8E0",
  attributes: {
    appearance: {
      dark: {
        value: "#49CC9333"
      }
    }
  }
};
export const BackgroundColorDanger = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const BackgroundColorDangerSubdued = {
  value: "#ffece9",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f33"
      }
    }
  }
};
export const BackgroundColorWarning = {
  value: "#ffbe00",
  attributes: {
    appearance: {
      dark: {
        value: "#ffe278"
      }
    }
  }
};
export const BackgroundColorDisabled = {
  value: "#606162",
  attributes: {
    appearance: {
      dark: {
        value: "#606162"
      }
    }
  }
};
export const BackgroundColorInverted = {
  value: "#2d2e31",
  attributes: {
    appearance: {
      dark: {
        value: "#fafafa"
      }
    }
  }
};
export const BackgroundColorInvertedStrong = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const BorderRadiusNone = { value: "0" };
export const BorderRadiusSmall = { value: "0.1875rem" };
export const BorderRadiusMedium = { value: "0.375rem" };
export const BorderRadiusLarge = { value: "0.75rem" };
export const BorderRadiusXlarge = { value: "1.5rem" };
export const BorderRadiusCircular = { value: "100%" };
export const BorderWidthNone = { value: "0rem" };
export const BorderWidth = { value: "0.0625rem" };
export const BorderWidthStrong = { value: "0.125rem" };
export const BorderColor = {
  value: "#949596",
  attributes: {
    appearance: {
      dark: {
        value: "#606162"
      }
    }
  }
};
export const BorderColorSubdued = {
  value: "#dfe0e1",
  attributes: {
    appearance: {
      dark: {
        value: "#444445"
      }
    }
  }
};
export const BorderColorStrong = {
  value: "#444445",
  attributes: {
    appearance: {
      dark: {
        value: "#dfe0e1"
      }
    }
  }
};
export const BorderColorPrimary = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const BorderColorSuccess = {
  value: "#007A4D",
  attributes: {
    appearance: {
      dark: {
        value: "#49CC93"
      }
    }
  }
};
export const BorderColorDanger = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const ChartsMonochrome01Color = {
  value: "#3892F3",
  attributes: {
    appearance: {
      dark: {
        value: "#8AC3FF"
      }
    }
  }
};
export const ChartsMonochrome01Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsMonochrome01Pattern = { value: "solid" };
export const ChartsMonochrome02Color = {
  value: "#08389c",
  attributes: {
    appearance: {
      dark: {
        value: "#3476FF"
      }
    }
  }
};
export const ChartsMonochrome02Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsMonochrome02Pattern = { value: "solid" };
export const ChartsMonochrome03Color = {
  value: "#F2F9FF",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ChartsMonochrome03Stroke = {
  value: "#3892F3",
  attributes: {
    appearance: {
      dark: {
        value: "#8AC3FF"
      }
    }
  }
};
export const ChartsMonochrome03Pattern = { value: "striped" };
export const ChartsMonochrome04Color = {
  value: "#F2F9FF",
  attributes: {
    appearance: {
      dark: {
        value: "#F2F9FF"
      }
    }
  }
};
export const ChartsMonochrome04Stroke = {
  value: "#3892F3",
  attributes: {
    appearance: {
      dark: {
        value: "#8AC3FF"
      }
    }
  }
};
export const ChartsMonochrome04Pattern = { value: "solid" };
export const ChartsCategorical10Color = {
  value: "#D57A5C",
  attributes: {
    appearance: {
      dark: {
        value: "#D99078"
      }
    }
  }
};
export const ChartsCategorical10Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical10Pattern = { value: "solid" };
export const ChartsCategorical01Color = {
  value: "#3892F3",
  attributes: {
    appearance: {
      dark: {
        value: "#3892F3"
      }
    }
  }
};
export const ChartsCategorical01Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical01Pattern = { value: "solid" };
export const ChartsCategorical02Color = {
  value: "#08389c",
  attributes: {
    appearance: {
      dark: {
        value: "#3476FF"
      }
    }
  }
};
export const ChartsCategorical02Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical02Pattern = { value: "solid" };
export const ChartsCategorical03Color = {
  value: "#0FA2B8",
  attributes: {
    appearance: {
      dark: {
        value: "#C6F6FF"
      }
    }
  }
};
export const ChartsCategorical03Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical03Pattern = { value: "solid" };
export const ChartsCategorical04Color = {
  value: "#907AF5",
  attributes: {
    appearance: {
      dark: {
        value: "#C6B8F4"
      }
    }
  }
};
export const ChartsCategorical04Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical04Pattern = { value: "solid" };
export const ChartsCategorical05Color = {
  value: "#DE52CE",
  attributes: {
    appearance: {
      dark: {
        value: "#D949A9"
      }
    }
  }
};
export const ChartsCategorical05Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical05Pattern = { value: "solid" };
export const ChartsCategorical06Color = {
  value: "#C2185B",
  attributes: {
    appearance: {
      dark: {
        value: "#ED1369"
      }
    }
  }
};
export const ChartsCategorical06Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical06Pattern = { value: "solid" };
export const ChartsCategorical07Color = {
  value: "#759E15",
  attributes: {
    appearance: {
      dark: {
        value: "#8CC30B"
      }
    }
  }
};
export const ChartsCategorical07Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical07Pattern = { value: "solid" };
export const ChartsCategorical08Color = {
  value: "#AC6400",
  attributes: {
    appearance: {
      dark: {
        value: "#B36800"
      }
    }
  }
};
export const ChartsCategorical08Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical08Pattern = { value: "solid" };
export const ChartsCategorical09Color = {
  value: "#EB7200",
  attributes: {
    appearance: {
      dark: {
        value: "#FFA037"
      }
    }
  }
};
export const ChartsCategorical09Stroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsCategorical09Pattern = { value: "solid" };
export const ChartsStatusSuccessColor = {
  value: "#007A4D",
  attributes: {
    appearance: {
      dark: {
        value: "#49CC93"
      }
    }
  }
};
export const ChartsStatusSuccessStroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsStatusSuccessPattern = { value: "solid" };
export const ChartsStatusWarningColor = {
  value: "#ffbe00",
  attributes: {
    appearance: {
      dark: {
        value: "#ffe278"
      }
    }
  }
};
export const ChartsStatusWarningStroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsStatusWarningPattern = { value: "solid" };
export const ChartsStatusDangerColor = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const ChartsStatusDangerStroke = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ChartsStatusDangerPattern = { value: "solid" };
export const ChartsStatusNeutralColor = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ChartsStatusNeutralStroke = {
  value: "#8C9CA5",
  attributes: {
    appearance: {
      dark: {
        value: "#B4C1C8"
      }
    }
  }
};
export const ChartsStatusNeutralPattern = { value: "striped" };
export const FocusRingColor = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const FocusRingColorDanger = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const FocusRingWidth = { value: "0.25rem" };
export const ForegroundColor = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const ForegroundColorSubdued = {
  value: "#737475",
  attributes: {
    appearance: {
      dark: {
        value: "#bcbcbd"
      }
    }
  }
};
export const ForegroundColorPrimary = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const ForegroundColorDanger = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const ForegroundColorInverted = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ForegroundColorOnPrimary = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ForegroundColorOnDanger = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ForegroundColorOnDangerSubdued = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const ForegroundColorOnWarning = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ForegroundColorActivePrimary = {
  value: "#004491",
  attributes: {
    appearance: {
      dark: {
        value: "#B5DEFF"
      }
    }
  }
};
export const ForegroundColorActiveDanger = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const ForegroundColorHoverPrimary = {
  value: "#004491",
  attributes: {
    appearance: {
      dark: {
        value: "#B5DEFF"
      }
    }
  }
};
export const ForegroundColorHoverDanger = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const OverlayColorActive = {
  value: "#14141429",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff29"
      }
    }
  }
};
export const OverlayColorActivePrimary = {
  value: "#0265DC4D",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA40"
      }
    }
  }
};
export const OverlayColorActiveDanger = {
  value: "#e132124D",
  attributes: {
    appearance: {
      dark: {
        value: "#f94d3240"
      }
    }
  }
};
export const OverlayColorActiveOn = {
  value: "#14141429",
  attributes: {
    appearance: {
      dark: {
        value: "#14141429"
      }
    }
  }
};
export const OverlayColorActiveOnPrimary = {
  value: "#14141466",
  attributes: {
    appearance: {
      dark: {
        value: "#14141429"
      }
    }
  }
};
export const OverlayColorActiveOnDanger = {
  value: "#14141466",
  attributes: {
    appearance: {
      dark: {
        value: "#14141429"
      }
    }
  }
};
export const OverlayColorHover = {
  value: "#14141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff14"
      }
    }
  }
};
export const OverlayColorHoverPrimary = {
  value: "#0265DC1A",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA1A"
      }
    }
  }
};
export const OverlayColorHoverDanger = {
  value: "#e132121A",
  attributes: {
    appearance: {
      dark: {
        value: "#f94d3226"
      }
    }
  }
};
export const OverlayColorHoverOn = {
  value: "#14141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff14"
      }
    }
  }
};
export const OverlayColorHoverOnPrimary = {
  value: "#14141433",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff29"
      }
    }
  }
};
export const OverlayColorHoverOnDanger = {
  value: "#14141433",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff29"
      }
    }
  }
};
export const ShadowColor = {
  value: "#14141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff14"
      }
    }
  }
};
export const ShadowSizeFlat = { value: "0rem 0rem 0rem" };
export const ShadowSizeFloat = { value: "0rem 0.125rem 0.5rem" };
export const ShadowSizeOverlay = { value: "0rem 0.5rem 1.5rem" };
export const StatusColorInfo = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const StatusColorDanger = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const StatusColorSuccess = {
  value: "#007A4D",
  attributes: {
    appearance: {
      dark: {
        value: "#49CC93"
      }
    }
  }
};
export const StatusColorWarning = {
  value: "#ffbe00",
  attributes: {
    appearance: {
      dark: {
        value: "#ffe278"
      }
    }
  }
};
export const TypographyParagraphSizeXsmall = { value: "0.75rem" };
export const TypographyParagraphSizeSmall = { value: "0.875rem" };
export const TypographyParagraphSize = { value: "1rem" };
export const TypographyParagraphSizeLarge = { value: "1.25rem" };
export const TypographyParagraphSizeXlarge = { value: "1.5rem" };
export const TypographyParagraphFontWeight = { value: "400" };
export const TypographyParagraphFontFamily = { value: "'Nunito Sans', sans-serif" };
export const TypographyHeadingSizeXsmall = { value: "0.875rem" };
export const TypographyHeadingSizeSmall = { value: "1rem" };
export const TypographyHeadingSize = { value: "1.25rem" };
export const TypographyHeadingSizeLarge = { value: "1.5rem" };
export const TypographyHeadingSizeXlarge = { value: "2rem" };
export const TypographyHeadingFontWeight = { value: "700" };
export const TypographyHeadingFontFamily = { value: "'Sofia Pro', SofiaPro, sans-serif" };
export const TypographyLabelSizeXsmall = { value: "0.625rem" };
export const TypographyLabelSizeSmall = { value: "0.75rem" };
export const TypographyLabelSize = { value: "0.875rem" };
export const TypographyLabelSizeLarge = { value: "1rem" };
export const TypographyLabelSizeXlarge = { value: "1.25rem" };
export const TypographyLabelFontWeight = { value: "600" };
export const TypographyLabelFontFamily = { value: "'Nunito Sans', sans-serif" };